export const urlLinkData = {
  home: "/",
  linkTree: "/link-tree",
  blog: "/blog",
  coach: "/coach-sanjam",
};
